<script setup lang="ts" name="RegistrationTradesSearchCount">
import { computed } from 'vue';

const { count, error } = defineProps<{
  count: number;
  error: boolean;
}>();

const selectedCount = computed(
  () => `<b>${count} of 10 added </b>. You can add up to 10 trades.`,
);
</script>

<template>
  <p
    v-if="count"
    data-test="registration-search-count"
    class="py-2 text-center text-sm text-charcoal-6"
    :class="{ 'text-red-6': error, 'text-charcoal-6': !error }"
    v-html="selectedCount"
  ></p>
</template>
